import { Button, DatePicker, message, Row, Table } from 'antd';
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "@/components/table/Auth";
import imgSave from "@/components/table/saveImg";
import dataDefault from './data';
import { columns, compute, nameList } from "./compute";
import request from "@/method/axios";
import _ from 'lodash';

const { MonthPicker } = DatePicker;

@inject('store')
@observer
class index extends Component {
    state = {
        date: moment().isBefore(moment('2023-12-31')) ? '2024-01' : moment().subtract(1, 'month').format('YYYY-MM'),
        data: [],
        loading: true,
        loadingSave: false,
        print: false,
        data4_1: [],
        key: "4_3_1_new_f",
        data1_1: []
    }

    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data) => {
        data = compute(data);
        this.setState({ data, loading: false, });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getData = async (date) => {
        try {
            this.setState({ loading: true });
            let data = JSON.parse(JSON.stringify(dataDefault));
            let month = moment(date).format('M');
            const year = moment(date).format('YYYY');
            if (this.state.key === '_4new_4_3_1_budget') month = null;
            const res = await request.get('/api/data', { year, month, key: this.state.key });
            if (res.data && res.data.length) data = res.data;

            // 强制填充实际数据
            if (this.state.key != '_4new_4_3_1_budget') {
                const last = await request.post('/api/data', {
                    list: [{ year, month: month - 1, key: this.state.key, name: 'last' }, { year, key: "_4new_4_3_1_budget", name: 'budget' }]
                });
                console.log(last);
                const name = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"][~~(month - 1)];
                // 当月预测数据不填充 
                if (last.data.last && last.data.last.length && !res.data.length) data = last.data.last.map(x => {
                    delete x.id;
                    return {
                        ...x,
                        [`${name}_adr`]: 0,
                        [`${name}_rev`]: 0,
                        [`${name}_rn`]: 0,
                        month,
                        year
                    }
                });
                if (last.data.last && last.data.last.length) data = last.data.last.map((x, index) => {
                    delete x.id;
                    return {
                        ...data[index],
                        ...["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"].reduce((a, b, i) => {
                            if (i < ~~(month - 1)) {
                                a = {
                                    ...a,
                                    [`${b}_adr`]: x[`${b}_adr`],
                                    [`${b}_rev`]: x[`${b}_rev`],
                                    [`${b}_rn`]: x[`${b}_rn`],
                                }
                            }
                            return a
                        }, {}),
                        month,
                        year
                    }
                });
                // 预算的实际可售房数填充
                if (last.data.budget && last.data.budget.length) {
                    nameList.forEach(name => {
                        data[35][`${name}_rn`] = data[35][`${name}_rn`] || _.get(last.data.budget, `35.${name}_rn`, 0);
                    });
                }
            }
            this.computeNum(data);
            this.getKpis(date);
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }

    getKpis = async (date) => {
        fetch(`/kpiInfo?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' })
            .then(x => x.json())
            .then(x => {
                this.setState({ data1_1: x.data || [] });
            })
    }

    onSave = async () => {
        try {
            let { date, key } = this.state;
            if (!date) return message.error('请选择年份月份');

            this.setState({ loadingSave: true });
            let year = moment(date).format("YYYY");
            let month = moment(date).format("M");
            let data = this.state.data.map((x, i) => {
                const res = ({ ...x, year, sort: i })
                if (key != '_4new_4_3_1_budget') res.month = month;
                return res;
            });
            const postData = {
                data,
                year,
                key,
            };
            if (key != '_4new_4_3_1_budget') postData.month = month;
            const x = await request.post(`/api/save`, postData);
            this.setState({ loadingSave: false });
            if (x.code == 200) {
                message.success("保存成功！");
                if (!data[0].id) this.getData(this.state.date);
            }
        } catch (err) {
            this.setState({ loadingSave: false });
            console.error(err);
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('view4_1_4', 1.5, '4.31', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')} 4.3.1 Market Segment by Month 市场细分明细表月度分解`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, date, print, loading, key, data1_1 } = this.state;

        return (
            <div className="table7_1_1 tableHeight">
                <Row className="title" id="view4_1_4" style={{ width: print ? 6150 : 'auto' }} >
                    <Row>4.3.1 Market Segment by Month 市场细分明细表月度分解</Row>
                    <Row className="table-month">
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            value={moment(this.state.date, "YYYY-MM")}
                            format="YYYY-MM"
                            disabledDate={v => {
                                if (moment(v).isAfter(moment('2023-12-31'))) return false;
                                return true;
                            }}
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                });
                                this.getData(str);
                            }}
                        />
                        <Button type={key == "4_3_1_new_f" ? 'primary' : 'default'}
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                                if (key === "4_3_1_new_f") return;
                                this.setState({ key: "4_3_1_new_f", data: [] }, () => {
                                    this.getData(date);
                                })
                            }}
                        >预测/实际</Button>
                        {/* <Button type={key == "4_3_1_new_a" ? 'primary' : 'default'}
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                                if (key === "4_3_1_new_a") return;
                                this.setState({ key: "4_3_1_new_a", data: [] }, () => {
                                    this.getData(date);
                                })
                            }}
                        >实际</Button> */}

                        <Button type={key == "_4new_4_3_1_budget" ? 'primary' : 'default'}
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                                if (key === "_4new_4_3_1_budget") return;
                                this.setState({ key: "_4new_4_3_1_budget", data: [] }, () => {
                                    this.getData(date);
                                })
                            }}
                        >预算</Button>
                    </Row>
                    <Table
                        columns={columns(this.onChange, date, key == '4_3_1_new_f' ? 1 : key == '_4new_4_3_1_budget' ? 3 : 2, print, data1_1)}
                        dataSource={data}
                        size="middle"
                        id="table4_1_4"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"

                        scroll={print ? {} : { x: true, y: 500 }}
                        rowKey={(record, index) => index}
                    />
                </Row>
                <Row className="table-footer-btn">
                    <Button
                        type="primary"
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel();
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>
                    <Auth loading={this.state.loading} auth="edit_4_3_1_new">
                        <Button
                            type="primary"
                            style={{ margin: '0 10px' }}
                            onClick={this.downloadSG}
                            loading={print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Auth>
                </Row>
            </div >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/4new/4.3/4.3.1/forecast.js